"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorEvent = exports.addErrorEventListener = void 0;
const errorListeners = {};
/**
 * Add callback to be called on API fetch error.
 * Returns a function that unsubscribes the given callback.
 * @param callback Callback function to be called with fetch error as its arg
 */
const addErrorEventListener = (callback) => {
    const id = String(Math.random());
    errorListeners[id] = callback;
    const removeListener = () => {
        delete errorListeners[id];
    };
    return removeListener;
};
exports.addErrorEventListener = addErrorEventListener;
/**
 * Call all callbacks in errorListeners
 * Exported for test only
 * @param error
 */
const handleErrorEvent = (error) => __awaiter(void 0, void 0, void 0, function* () {
    const listeners = Object.values(errorListeners);
    yield Promise.all(listeners.map((listener) => listener(error)));
});
exports.handleErrorEvent = handleErrorEvent;
//# sourceMappingURL=error.js.map